import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/store';

import LoginPage from './pages/login.vue';
import ForgotPasswordPage from './pages/forgot.vue';
import ResetPasswordPage from './pages/reset.vue';
import VerifyPage from './pages/verify.vue';
import BasicInfoPage from './pages/basic-info.vue';
import AssetsPage from './pages/assets.vue';
import IndoorAssetsPage from './pages/indoor-assets.vue';
import SettingsPage from './pages/configuration/settings.vue';
import SitesPage from './pages/configuration/sites.vue';
import ThemingPage from './pages/configuration/theming.vue';
import DevicesPage from './pages/configuration/devices.vue';
import UsersPage from './pages/configuration/users.vue';
import WorkflowPage from './pages/configuration/workflows.vue';
import ReportsPage from './pages/configuration/reports.vue';
import HealthPage from './pages/configuration/health.vue';
import SearchPage from './pages/configuration/search.vue';
import OrganizationSelect  from './pages/organization-select.vue';
import EulaPage from './pages/eula.vue';
import DashboardPage from './pages/dashboard.vue';
import KibanaPage from './pages/kibana.vue';
import TableauPage from './pages/tableau.vue';
import HelpPage from './pages/help.vue';
import SLAPage from './pages/configuration/sla.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: LoginPage,
  },
  {
    path: '/forgot',
    component: ForgotPasswordPage,
  },
  {
    path: '/resetpassword',
    component: ResetPasswordPage,
  },
  {
    path: '/verify',
    component: VerifyPage,
  },
  {
    path: '/eula',
    meta: { title: 'sidebar-eula' },
    component: EulaPage,
  },
  {
    path: '/org-select',
    meta: { layout: 'no-org-layout', title: 'sidebar-org-select' },
    component: OrganizationSelect,
  },
  {
    path: '/search',
    meta: { layout: 'no-org-layout', title: 'sidebar-settings-search' },
    component: SearchPage,
  },
  {
    path: '/assets',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-assets',
      headerSites: true,
      headerAreas: true,
      headerToggle: true,
    },
    component: AssetsPage,
  },
  {
    path: '/indoor-assets',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-assets-indoor',
      headerSites: true,
      headerAreas: true,
      headerToggle: true,
    },
    component: IndoorAssetsPage,
  },
  {
    path: '/basic-info',
    meta: { layout: 'full-layout' },
    component: BasicInfoPage,
  },
  {
    path: '/configuration/sites',
    meta: { layout: 'full-layout', title: 'sidebar-settings-sites' },
    component: SitesPage,
  },
  {
    path: '/system/settings',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-supertag-settings',
      headerSites: true,
    },
    component: SettingsPage,
  },
  {
    path: '/configuration/devices',
    meta: { layout: 'full-layout' },
    component: DevicesPage,
  },
  {
    path: '/configuration/theming',
    meta: { layout: 'full-layout', title: 'sidebar-settings-theming' },
    component: ThemingPage,
  },
  {
    path: '/configuration/users',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-settings-basic-users',
      headerSites: true,
    },
    component: UsersPage,
  },
  {
    path: '/events/workflows',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-settings-workflows',
      headerSites: true,
    },
    component: WorkflowPage,
  },
  {
    path: '/events/reports',
    meta: { layout: 'full-layout', title: 'sidebar-settings-reports', headerSites: true },
    component: ReportsPage,
  },
  {
    path: '/system/health',
    meta: { layout: 'full-layout', title: 'sidebar-settings-health', headerSites: true },
    component: HealthPage,
  },
  {
    path: '/system/search',
    meta: { layout: 'full-layout', title: 'sidebar-settings-search', headerSites: false },
    component: SearchPage,
  },
  {
    path: '/dashboard',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-dashboard',
      headerSites: true,
    },
    component: DashboardPage,
  },
  {
    path: '/sla',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-sla',
      headerSites: true,
    },
    component: SLAPage,
  },
  {
    path: '/kibana',
    meta: {
      layout: 'full-layout',
      headerSites: false,
    },
    component: KibanaPage,
  },
  {
    path: '/tableau',
    meta: {
      title: 'tableau',
      layout: 'full-layout',
      headerSites: false,
    },
    component: TableauPage,
  },
  {
    path: '/help',
    meta: { layout: 'full-layout', title: 'sidebar-help', headerSites: false },
    component: HelpPage,
  },
  {
    path: '/*',
    redirect: '/assets',
  },
];

const router = new VueRouter({ mode: 'history', routes });
router.beforeEach((to, _, next) => {
  // todo: find a better way to do this
  // allow these 3 routes to be always accessible
  if (window && window.ga) {
    //Google Analytics
    ga('send', 'pageview', to.path);
  }
  if (
    to.path !== '/forgot' &&
    to.path !== '/resetpassword' &&
    to.path !== '/verify'
  ) {
    if (to.path !== '/') {
      //internal pages
      if (store.getters.getUserLogged) {
        next();
      } else {
        next('/');
      }
    } else {
      //login page
      if (store.getters.getUserLogged) {
        next('/assets');
      }
    }
  }
  next();
});

export default router;
